let capturedOrigin: string | null = null;

const isUsable = (o: string | null | undefined): o is string => !!o && o !== "null";

function originFromAncestors(): string | null {
    try {
        const a = window.location.ancestorOrigins;
        return a?.length && isUsable(a[0]) ? a[0] : null;
    } catch {
        return null; // Not implemented everywhere (e.g. Firefox).
    }
}

function originFromReferrer(): string | null {
    try {
        return document.referrer ? new URL(document.referrer).origin : null;
    } catch {
        return null;
    }
}

/**
 * Records the opener's origin as a last-resort fallback.
 */
export function captureTrustedOrigin(event: MessageEvent): void {
    if (event.source === window.opener && isUsable(event.origin) && !capturedOrigin) {
        capturedOrigin = event.origin;
    }
}

/**
 * Trusted origin of the opener, or null if unknown (callers should fail closed).
 */
export function getTrustedOrigin(): string | null {
    return originFromAncestors() || originFromReferrer() || capturedOrigin;
}
